<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    class="nav-item"
    :class="{ active: isActive }"
    tag="li"
  >
    <a
      v-if="isMenu"
      class="nav-link sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click="collapseMenu"
    >
      <img :src="icon" alt="" class="icon-left-menu" />
      <p>
        {{ link.name }}
        <strong class="caret custom-caret"></strong>
      </p>
    </a>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition>
        <ul class="nav" v-show="!collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>

    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path"
    >
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        :class="{ active: link.active }"
        class="nav-link"
        :target="link.target"
        :href="link.path"
      >
        <template v-if="addLink">
          <img :src="icon" alt="" class="custom-img-subitem icon-left-menu" />
          <span class="sidebar-normal">{{ link.name }}</span>
          <em
            v-if="link.icon_right != null"
            :class="link.icon_right"
            class="icon-right-menu"
          ></em>
        </template>
        <template v-else>
          <img :src="icon" alt="" class="icon-left-menu" />
          <p>{{ link.name }}</p>
          <em
            v-if="link.icon_right != null"
            :class="link.icon_right"
            class="icon-right-menu"
          ></em>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMasters from 'src/util/mixinMasters';
import { BASE_URL } from 'src/util/Util';

export default {
  name: 'sidebar-item',
  components: {
    [CollapseTransition.name]: CollapseTransition,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          path: '',
          children: [],
        };
      },
    },
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild,
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
      icon: '/static/img/iconos/' + this.link.icon + '.svg',
      baseURL: BASE_URL,
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find((c) =>
          this.$route.path.startsWith(c.link.path)
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
  },
  mixins: [MixinPermissions, MixinMasters],
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    linkClick() {
      if (
        this.$route.path === '/notaccess' ||
        (sessionStorage.getItem('urlModule') &&
          sessionStorage.getItem('urlModule') == this.$route.path)
      )
        this.$emit('dashLoading', false);
      else this.$emit('dashLoading', this.isIndex());

      sessionStorage.setItem('moduleId', this.link.id);
      sessionStorage.setItem('urlModule', this.$route.path);
      this.$emit('load-icon-content', this.link.icon);

      for (let key of document.getElementsByClassName('icon-left-menu')) {
        if (key.parentElement.dataset['toggle'] == 'collapse')
          key.parentElement.className = 'nav-link sidebar-menu-item';
        else {
          if (
            !('/' + key.parentElement.href.replace(this.baseURL, '')).includes(
              this.$route.path
            ) ||
            key.parentElement.href.includes('notaccess')
          ) {
            key.parentElement.parentElement.className = 'nav-item';
            key.parentElement.className = 'nav-link';
          }
        }

        if (
          key.parentElement.parentElement.parentElement.tagName.toLowerCase() ==
            'ul' &&
          key.parentElement.parentElement.parentElement.parentElement.tagName.toLowerCase() ==
            'div' &&
          key.parentElement.parentElement.parentElement.parentElement.parentElement.tagName.toLowerCase() ==
            'li' &&
          key.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains(
            'custom-active-menu'
          )
        ) {
          key.parentElement.parentElement.parentElement.parentElement.parentElement.className =
            'nav-item';
        }
      }

      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }

      store.dispatch('auth/validateActiveSession').then((response) => {
        if (
          response.data.session == 0 ||
          (response.data.session == 1 && response.data.token == 0)
        ) {
          this.routeLogin(
            !(response.data.session == 1 && response.data.token == 0)
          );
        } else {
          store.dispatch('auth/validatePassTime', store.state.auth.user.id);
        }
      });
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
    isMenuActive(link) {
      return link.path === this.$route.path;
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
    if (this.isMenuActive(this.link)) {
      this.$emit('load-icon-content', this.link.icon);
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style>
.sidebar-menu-item {
  cursor: pointer;
}
</style>
